<div class="list-group-item product-views" *ngIf="views">
	<span>{{ views.total | i18nPlural: pluralMapping }} since {{ views.loadDateDisplay }}</span>
</div>
<div class="metadata-panel-header">
	<ul ngbNav #nav="ngbNav" class="nav nav-pills nav-justified">
	  <li ngbNavItem class="nav-item">
	    <a class="nav-link" ngbNavLink (click)="activeTab = 'standard'">
	      {{ LOCALIZATION.standardMetadata }}
	    </a>			    
	    <ng-template ngbNavContent>
			<div *ngFor='let field of Object.values(record)' class="list-group-item">
				<h4 class="list-group-item-heading">{{field.label}}</h4>
				<div *ngIf="field.links" >
				<div *ngIf="field.name == 'browsepath'" > 
	                <ul class="link-list">
	                    <li *ngFor="let link of field.links">
	                        <a class="pointMe" (click)="handleBrowsepathLink(link.href)"> 
	                            {{link.name.replace('////','//')}} 
	                        </a>
	                    </li>
	                </ul>
	            </div>
	            <div *ngIf="field.name != 'browsepath'" > 
	                <ul class="link-list">
	                    <li *ngFor="let link of field.links">
	                        <a *ngIf="link.href.indexOf('file://')!=10" 
	                            href="{{link.href.replace('////','//')}}" 
	                            target="_blank" 
	                            (click)="displayLinkMsg(link.href)"> 
	                            {{link.name.replace('////','//')}} 
	                        </a>
	                    </li>
	                </ul>
	            </div>				 
				</div>
	            <div *ngIf="!field.links && searchableMetadataFields.includes(field.name)">
					<a *ngIf="field.isValidCollection" 
					   class="pointMe" 
					   (click)="resultFieldSearch(field.name, field.cleanedValue)" 
					   [title]="field.cleanedValue">
					  {{ field.cleanedValue }}
					</a> 
	                <p *ngIf="!field.isValidCollection"
	                    class='dd-text-collapse'
	                    ddTextCollapse
	                    [ddTextCollapseMaxLength]="field.maxLength" 
	                    [ddTextCollapseText]="field.cleanedValue">
	                </p>
	            </div>                                  
	            <p *ngIf="!field.links && !searchableMetadataFields.includes(field.name)"
	               class='dd-text-collapse'
	               ddTextCollapse
	               [ddTextCollapseMaxLength]="field.maxLength" 
	               [ddTextCollapseText]="field.value">
	            </p>			
			</div> 
	    </ng-template>
	  </li>
	  <li class="nav-item" *ngFor="let tab of tabs; let i = index" [ngbNavItem]="i" [hidden]="!tab.canaccess">
	    <a class="nav-link" ngbNavLink (click)="activeTab = tab.id">
	      {{ tab.title }}
	    </a>
	    <ng-template ngbNavContent>
              <div class="metadata-alt-format"><pre>{{tab.metadata}}</pre></div>
	    </ng-template>	    
	  </li>	  
	</ul>   
</div> 	
<div class="panel-body">
	<div [ngbNavOutlet]="nav" class="tab-content"></div>
</div>
